import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IEnvironment } from '../../models/environment.model';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  private readonly environment: IEnvironment;
  private lastFetchTime: number | null = null;
  private readonly cacheDuration = 24 * 60 * 60 * 1000; // ⏳ 24 hours

  constructor(
    private readonly http: HttpClient,
    @Inject('environment') environment: IEnvironment
  ) {
    this.environment = environment;
    if (!this.environment.apiGatewayBaseUrl) {
      throw new Error(
        'useBaseUrl: portal environment ApiGatewayBaseUrl property is required'
      );
    }
  }

  getApplicationStates() {
    const now = Date.now();

    // Return cached application states if available and not expired
    const storedData = localStorage.getItem('applicationStates');
    if (
      storedData &&
      this.lastFetchTime &&
      now - this.lastFetchTime < this.cacheDuration
    ) {
      console.log('Returning cached application states...');
      return JSON.parse(storedData);
    }

    // Fetch fresh data and store it
    const url = `${this.environment.apiGatewayBaseUrl}/application/v1/application-states`;
    this.http.get<Record<string, unknown>>(url).subscribe((data: any) => {
      localStorage.setItem('applicationStates', JSON.stringify(data['data']));
      this.lastFetchTime = now;
    });

    const newStoredData = localStorage.getItem('applicationStates');
    if (newStoredData) {
      return JSON.parse(newStoredData);
    }
  }
}

export function getApplicationStateLabel(applicationState: string): string {
  const states = localStorage.getItem('applicationStates');
  if (states) {
    const applicationStates: any[] = JSON.parse(states);
    if (applicationStates) {
      const foundItem = applicationStates?.find(
        (item: any) => item && item['stateName'] === applicationState
      );
      if (foundItem) {
        return foundItem?.stateLabel;
      }
    }
  }
  return applicationState;
}

export function getApplicationStateColor(applicationState: string): string {
  const states = localStorage.getItem('applicationStates');
  if (states) {
    const applicationStates: any[] = JSON.parse(states);
    if (applicationStates) {
      const foundItem = applicationStates?.find(
        (item: any) => item && item['stateName'] === applicationState
      );
      if (foundItem) {
        return foundItem?.stateColor;
      }
    }
  }
  return 'primary';
}
